import { render, staticRenderFns } from "./statisticalList.vue?vue&type=template&id=6c9ecfda&"
import script from "./statisticalList.vue?vue&type=script&lang=js&"
export * from "./statisticalList.vue?vue&type=script&lang=js&"
import style0 from "./statisticalList.vue?vue&type=style&index=0&id=6c9ecfda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports